import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    //ADD DOCKET FORM TRIP
    start: "",
    end: "",
    tip: "",
    spoil: "",
    siteWeight: 0,
    scaleWeight: 0,
    tipWeight: 0,
    qty: 0,
    breaks: 0,
    travel: 0,
    wbDocketNumber: "",
    notes: "",
    displayRate: null,
    tripRate: null,
    totalBreaks: 0,
    totalTravel: 0,
    useNightRate: false,
    useAltRate: false,
    useOverrideCost: false,

    //TRIP PAGE VALUES
    //showCredit: false,
    selected: [],
    selectedAll: false,
    trips: [],
    dates: [],
    //billingPeriod: "2019-02",
    filterBy: "",
    filterCol: "",
    filterBy2: "",
    filterCol2: "",
    pagination: {},
    fetchTrips: false
    // defaultHeaders: [
    //     'docket.date',
    //     'docket.externalRef',
    //     'docket.site.name',
    //     'spoil.name',
    //     'hours',
    //     'siteWeight',
    //     'costTotal',
    //     'sellTotal'
    // ],
    //drawer: false
  },
  mutations: Mutations,
  actions: {
    resetTripOnDocketSubmitted(context) {
      context.commit('setState', { prop: 'start', value: '' })
      context.commit('setState', { prop: 'end', value: '' })
      context.commit('setState', { prop: 'tip', value: '' })
      context.commit('setState', { prop: 'spoil', value: '' })
      context.commit('setState', { prop: 'qty', value: 0 })
      context.commit('setState', { prop: 'wbDocketNumber', value: '' })
      context.commit('setState', { prop: 'notes', value: '' })
      context.commit('setState', { prop: 'totalBreaks', value: 0 })
      context.commit('setState', { prop: 'totalTravel', value: 0 })
      context.commit('setState', { prop: 'useNightRate', value: false })
      context.commit('setState', { prop: 'useAltRate', value: false })
    }
  },
  getters: {
  }
}